import { snakeToPascal, splitWordsOnUpperCase } from "@repo/helpers";
import { Column, GridPreLoaded } from "@repo/ui";

import { useRepIncidentQueries } from "../../../../api/repIncidentApi";
import { Complaint } from "../../../../models";
import { SurveyResponse } from "../../../../models/surveys";
import { Props } from "./types";

export default function ComplaintSurveyGrid(props: Props) {
	const { useSurveyResponsesQuery } = useRepIncidentQueries();
	const incident = props.component.propertyValue as Complaint;

	const { data, loaded, clearQuery } = useSurveyResponsesQuery(incident.id);

	return (
		<>
			<a target="_blank" href={`/MVC/Surveys/SurveyReceipt?surveyCode=${incident.surveyCode}`} rel="noreferrer">
				Show Receipt
			</a>
			<GridPreLoaded {...props} values={data?.data ?? []} loading={!loaded} getData={clearQuery} />
		</>
	);
}

const FormatColumn = (text: string) => splitWordsOnUpperCase(snakeToPascal(text));

ComplaintSurveyGrid.defaultProps = {
	columns: [
		new Column("Question", "questionTag").withFormat(FormatColumn),
		new Column("Answer", "value").withFormat(FormatColumn),
	] as Column<SurveyResponse>[],
	title: null,
	id: "complaintSurveyGrid",
	values: [],
	keyProperty: "surveyResponseId",
	pageSize: 5,
} as Props;
